import { Component, Input } from '@angular/core';

@Component({
  selector: 'prgov-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Estamos guardando los cambios en el sistema';
  @Input() subtitle: string = 'Por favor, espera unos segundos.';
  @Input() warningText: string = 'No recargues ni cierres el navegador, ya que podrías interrumpir el proceso y perder los datos ingresados.';
  @Input() autoCloseText: string = 'Esta ventana se cerrará sola.';
}

